import { render, staticRenderFns } from "./promoteRule.vue?vue&type=template&id=15d0929e&scoped=true"
import script from "./promoteRule.vue?vue&type=script&lang=js"
export * from "./promoteRule.vue?vue&type=script&lang=js"
import style0 from "./promoteRule.vue?vue&type=style&index=0&id=15d0929e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0929e",
  null
  
)

export default component.exports